import React, { useContext, useState } from 'react';
import TabListComponent from '@components/Core/Tabs/TabList/TabList.component';
import { TemplateLibraryItem } from '../TemplateLibrary/TemplateLibrary.component';
import MergeFloTemplates from '../MergeFloTemplates/MergeFloTemplates.component';
import { useTranslation } from 'react-i18next';
import PersonalTemplatesTab from '../PersonalTemplatesTab/PersonalTemplatesTab.component';
import { TemplateLibraryContext, TemplateLibraryContextType } from '../TemplateLibrary/TemplateLibrary.context';
import './TemplateLibraryTabs.scss';

export interface TemplateLibraryProps {
  templateLibraries: TemplateLibraryItem[];
};

const TemplateLibraryTabs = () => {
  const [tabIndex, setTabIndex] = useState<string>('1');
  const { 
    onUpdateSelectedTab,
  } = useContext(TemplateLibraryContext) as TemplateLibraryContextType;
  const { t } = useTranslation();

  const tabListProps = {
    tabLabel: "Template library tabs",
    className: "TemplateLibraryTabs",
    tabItems: [
      { label: t('templates.mergeflo_curated'), content: (<MergeFloTemplates />) },
      { label: t('templates.personal_saved_templates'), content: (<PersonalTemplatesTab />) },
    ],
    handleChange: (event: React.SyntheticEvent, value: any) => {
      setTabIndex(value);
      onUpdateSelectedTab(value);
    }
  };
  return (
    <TabListComponent {...tabListProps} tabIndex={tabIndex} />
  )
}

export default TemplateLibraryTabs;
 